export enum IframeAllowValue {
  Fullscreen = "fullscreen",
}

export enum VideoSourceUrl {
  ScmpWidget = "widgets.scmp.com",
  Youtube = "www.youtube.com",
}
